import { useEffect, useState, useContext } from 'react'
import { 
  userIconDefault,
  userIconSelected,
  questionIconDefault,
  questionIconSelected,
  houseIconDefault,
  houseIconSelected
} from '../../common/iconPaths'
import LeftNavigation from '../../common/leftNavigation';
import { DataContext, DataDispatchContext } from '../../../contexts/data/dataContext'
import { clickAnalyticsProfile } from '../../common/util/util'

export default function ProfileLeftNavigation(
    { acctSelected }: any
  ) {
    const data = useContext(DataContext)
    const dispatch: any = useContext(DataDispatchContext)
    const [selected, setSelected] = useState(data?.acctSelected || 'details');

 
    const handleMenuClick = (event: any) => {
      const id = event.currentTarget.id
      if(id !== data?.acctSelected) {
        setSelected(id)
        dispatch({
          type: 'setAcctSelected',
          acctSelected: id
        })
        clickAnalyticsProfile(id)
      }
    }

    useEffect(() => {
      if( selected !== data?.acctSelected ) {
        setSelected(data?.acctSelected)
        // setMenuSelected(data?.acctSelected)
      }
    },[selected, data?.acctSelected])

    const navItemList = [
        {
            id: 'details',
            name: "Your account",
            iconPath: userIconDefault,
            selected: userIconSelected,
            action: handleMenuClick
        },
        {
            id: 'system',
            name: "Your system",
            iconPath: houseIconDefault,
            selected: houseIconSelected,
            action: handleMenuClick
        },
        {
            id: 'help',
            name: "Help & support",
            iconPath: questionIconDefault,
            selected: questionIconSelected,
            action: handleMenuClick
        },
        // {
        //     id: 'signout',
        //     name: "Sign out",
        //     iconPath: signOutIconPath,
        //     selected: signOutIconPath,
        //     action: handleMenuClick
        // }
      ]

    return (
      <LeftNavigation 
          itemSelected={acctSelected} 
          defaultSelected={"details"}
          title={"Profile"} 
          navItemList={navItemList}
          />
    )
}